const copyProductUrl = async (url) => {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(url);
    return true;
  }

  const input = document.createElement('textarea');
  input.value = url;
  input.setAttribute('readonly', '');
  input.style.position = 'fixed';
  input.style.opacity = '0';
  document.body.appendChild(input);
  input.select();

  const copied = document.execCommand('copy');
  input.remove();
  return copied;
};

const showShareConfirmation = (button, message) => {
  const label = button.querySelector('[data-ch-share-label]');
  const status = button.querySelector('[data-ch-share-status]');

  if (label) label.textContent = message;
  if (status) status.textContent = message === 'Copied' ? 'Product link copied.' : message;

  window.setTimeout(() => {
    if (label) label.textContent = 'Share';
    if (status) status.textContent = '';
  }, 1800);
};

document.addEventListener('click', async (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const button = target.closest('[data-ch-share-product]');
  if (!(button instanceof HTMLButtonElement)) return;

  const title = button.dataset.shareTitle || document.title;
  const url = window.location.href || button.dataset.shareUrl;

  try {
    if (navigator.share) {
      await navigator.share({ title, url });
      return;
    }

    const copied = await copyProductUrl(url);
    showShareConfirmation(button, copied ? 'Copied' : 'Copy link');
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') return;

    try {
      const copied = await copyProductUrl(url);
      showShareConfirmation(button, copied ? 'Copied' : 'Copy link');
    } catch {
      showShareConfirmation(button, 'Copy link');
    }
  }
});
